<template>
  <router-view :key="$route.params.section" />
</template>

<script>
export default {
  name: 'SettingsWrapper',
}
</script>
